import { BASE_PATH } from '@/router/routes/constants';
import { Pages } from '@/types';
import { HgSupportedLanguage } from '@smg-real-estate/domus';

export const isTargetPageByPath = (
  path: string,
  routes: Record<HgSupportedLanguage, string>,
  dynamicParams = false,
): boolean => {
  const valuationPaths = Object.values(routes).map((route) => {
    const regexPath = dynamicParams ? route.replace(/:([^/]+)/g, '[^/]+') : route;
    return new RegExp(`^${regexPath.replace(/\//g, '\\/')}\\/?$`);
  });

  return valuationPaths.some((regex) => regex.test(path));
};

/**
 * TODO: Add login callback urls to auth0 whitelisted urls when needed: "/<language>/price-check/login-callback"
 * Temp solution to use property-valuation/login-callback for now.
 */
export const getLoginCallbackUrl = (includeOrigin = true): string => {
  const path = `/en/property-valuation/login-callback`;
  if (includeOrigin) return `${window.location.origin}${path}`;
  return path;
};

export const isLandingPage = (path: string): boolean => {
  return isTargetPageByPath(path, BASE_PATH);
};

export const getPage = (path: string): Pages | null => {
  // Match the router order from specific to general
  const pages = {
    [Pages.LP]: isLandingPage(path),
  };
  return (Object.keys(pages).find((key) => pages[key]) as Pages) ?? null;
};
